<template>
  <button type="button" class="btn btn-success" @click="show = true">Add Passenger</button>
  <div class="modal" tabindex="-1" :class="show ? 'fade show' : ''" v-show="show">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Passenger</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="show = false"></button>
        </div>
        <div class="modal-body">
          <form ref="addPassenger">
            <Passenger :passenger="passenger" />
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-danger" data-bs-dismiss="modal" @click="show = false">Close</button>
          <button type="button" class="btn btn-primary" @click="addToPassengers()">Add Passenger</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" v-show="show"></div>
</template>

<script>
import Passenger from '@/components/Form/Passenger'
export default {
  name: 'AddPassenger',
  components: {
    Passenger
  },
  props: ['customers'],
  data() {
    return {
      show: false,
      passenger: this.$inertia.form({
        customers_id: this.customers.id,
        sex: null,
        given_names: null,
        surname: null,
        dob: null,
        nationality: null,
        passport_number: null,
        passport_issue: null,
        passport_expire: null,
      }),
    }
  },
  methods: {
    addToPassengers() {
      this.passenger.post(`/passengers`)

      this.passenger.reset();

      // this.$refs.addPassenger.reset()

      // this.passenger.sex = null;
      // this.passenger.given_names = null;
      // this.passenger.surname = null;
      // this.passenger.dob = null;
      // this.passenger.nationality = null;
      // this.passenger.passport_number = null;
      // this.passenger.passport_issue = null;
      // this.passenger.passport_expire = null;

      this.show = false;
    }
  }
}
</script>

<style>
.modal.show {
  display: block;
}
</style>
